import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { PostingsState } from "@reducers/types/HRM/postings-state";

import {
  getPostingsRequest,
  updateAbroadPostingsInfoRequest,
  updateDeputationPostingsInfoRequest,
  updatePostingRecordPostingsInfoRequest,
  updateForeignTravelPostingsInfoRequest,
  deleteAbroadPostingInfoRequest,
  deleteDeputationPostingInfoRequest,
  deletePostingRecordPostingInfoRequest,
  deleteForeignTravelPostingInfoRequest,
} from "@actions/HRM/employee/postings-action";
import { getPostingsState } from "@selectors/HRM/employee/postings-info-selector";

import { useAppSelector } from "@helpers/redux";
import {
  PostingsType,
  AbroadPostingType,
  DeputationPostingType,
  PostingRecordPostingType,
  ForeignTravelPostingType,
} from "@type/HRM/postings";
interface UsePostings {
  getPostingRequestOngoing: boolean;

  updateAbroadPostingRequestOngoing: boolean;
  updateAbroadPostingSuccess: boolean;
  updateAbroadPostingFailed: boolean;

  updateDeputationPostingRequestOngoing: boolean;
  updateDeputationPostingSuccess: boolean;
  updateDeputationPostingFailed: boolean;

  updatePostingRecordPostingRequestOngoing: boolean;
  updatePostingRecordPostingSuccess: boolean;
  updatePostingRecordPostingFailed: boolean;

  updateForeignTravelPostingRequestOngoing: boolean;
  updateForeignTravelPostingSuccess: boolean;
  updateForeignTravelPostingFailed: boolean;

  deleteAbroadPostingRequestOngoing: boolean;
  deleteAbroadPostingSuccess: boolean;
  deleteAbroadPostingFailed: boolean;

  deleteDeputationPostingRequestOngoing: boolean;
  deleteDeputationPostingSuccess: boolean;
  deleteDeputationPostingFailed: boolean;

  deletePostingRecordPostingRequestOngoing: boolean;
  deletePostingRecordPostingSuccess: boolean;
  deletePostingRecordPostingFailed: boolean;

  deleteForeignTravelPostingRequestOngoing: boolean;
  deleteForeignTravelPostingSuccess: boolean;
  deleteForeignTravelPostingFailed: boolean;

  postingsInfo: PostingsType;

  changeAbroadPostingsInfo: (
    updateAboardPostingInfo: AbroadPostingType,
  ) => void;
  changeDeputationPostingsInfo: (
    updateDeputationPostingInfo: DeputationPostingType,
  ) => void;
  changePostingRecordPostingsInfo: (
    updatePostingRecordPostingInfo: PostingRecordPostingType,
  ) => void;
  changeForeignTravelPostingsInfo: (
    updateForeignTravelPostingInfo: ForeignTravelPostingType,
  ) => void;

  removeAbroadPostingInfo: (abroadPostingID: number) => void;
  removeDeputationPostingInfo: (deputationPostingID: number) => void;
  removePostingRecordPostingInfo: (postingRecordPostingID: number) => void;
  removeForeignTravelPostingInfo: (foreignTravelPostingID: number) => void;
}

export const usePostings = (id: number | null): UsePostings => {
  const dispatch = useDispatch();
  const {
    data,

    getPostingRequestOngoing,

    updateAbroadPostingRequestOngoing,
    updateAbroadPostingSuccess,
    updateAbroadPostingFailed,

    updateDeputationPostingRequestOngoing,
    updateDeputationPostingSuccess,
    updateDeputationPostingFailed,

    updatePostingRecordPostingRequestOngoing,
    updatePostingRecordPostingSuccess,
    updatePostingRecordPostingFailed,

    updateForeignTravelPostingRequestOngoing,
    updateForeignTravelPostingSuccess,
    updateForeignTravelPostingFailed,

    deleteAbroadPostingRequestOngoing,
    deleteAbroadPostingSuccess,
    deleteAbroadPostingFailed,

    deleteDeputationPostingRequestOngoing,
    deleteDeputationPostingSuccess,
    deleteDeputationPostingFailed,

    deletePostingRecordPostingRequestOngoing,
    deletePostingRecordPostingSuccess,
    deletePostingRecordPostingFailed,

    deleteForeignTravelPostingRequestOngoing,
    deleteForeignTravelPostingSuccess,
    deleteForeignTravelPostingFailed,
  } = useAppSelector<PostingsState>(getPostingsState);

  //GET
  useEffect(() => {
    dispatch(getPostingsRequest(id));
  }, [dispatch, id]);
  const postings = data;

  //UPDATE ABROAD POSTING INFO
  const changeAbroadPostingsInfo = (
    updateAbroadPostingInfo: AbroadPostingType,
  ) =>
    dispatch(
      updateAbroadPostingsInfoRequest({
        employeeID: id,
        ...updateAbroadPostingInfo,
      } as AbroadPostingType),
    );

  //UPDATE ATTACHMENT POSTING INFO
  // const changeAttachmentPostingsInfo = (
  //   updateAttachmentPostingInfo: AttachmentPostingType
  // ) =>
  //   dispatch(
  //     updateAttachmentPostingsInfoRequest({
  //       employeeID: id,
  //       ...updateAttachmentPostingInfo,
  //     } as AttachmentPostingType)
  //   );

  //UPDATE CONTRACTUAL POSTING INFO
  // const changeContractualPostingsInfo = (
  //   updateContractualPostingInfo: ContractualPostingType
  // ) =>
  //   dispatch(
  //     updateContractualPostingsInfoRequest({
  //       employeeID: id,
  //       ...updateContractualPostingInfo,
  //     } as ContractualPostingType)
  //   );

  //UPDATE DEPUTATION POSTING INFO
  const changeDeputationPostingsInfo = (
    updateDeputationPostingInfo: DeputationPostingType,
  ) =>
    dispatch(
      updateDeputationPostingsInfoRequest({
        employeeID: id,
        ...updateDeputationPostingInfo,
      } as DeputationPostingType),
    );

  //UPDATE POSTING RECORD POSTING INFO
  const changePostingRecordPostingsInfo = (
    updatePostingRecordPostingInfo: PostingRecordPostingType,
  ) =>
    dispatch(
      updatePostingRecordPostingsInfoRequest({
        employeeID: id,
        ...updatePostingRecordPostingInfo,
      } as PostingRecordPostingType),
    );

  //UPDATE FOREIGN TRAVEL POSTING INFO
  const changeForeignTravelPostingsInfo = (
    updateForeignTravelPostingInfo: ForeignTravelPostingType,
  ) =>
    dispatch(
      updateForeignTravelPostingsInfoRequest({
        employeeID: id,
        ...updateForeignTravelPostingInfo,
      } as ForeignTravelPostingType),
    );

  //DELETE ABROAD POSTINGS INFO
  const removeAbroadPostingInfo = (abroadPostingID: number) =>
    dispatch(
      deleteAbroadPostingInfoRequest({
        employeeID: id,
        abroadPostingID,
      }),
    );

  //DELETE DEPUTATION POSTINGS INFO
  const removeDeputationPostingInfo = (deputationPostingID: number) =>
    dispatch(
      deleteDeputationPostingInfoRequest({
        employeeID: id,
        deputationPostingID,
      }),
    );

  //DELETE POSTING RECORD POSTINGS INFO
  const removePostingRecordPostingInfo = (postingRecordPostingID: number) =>
    dispatch(
      deletePostingRecordPostingInfoRequest({
        employeeID: id,
        postingRecordPostingID,
      }),
    );

  //DELETE FOREIGN TRAVEL POSTINGS INFO
  const removeForeignTravelPostingInfo = (foreignTravelPostingID: number) =>
    dispatch(
      deleteForeignTravelPostingInfoRequest({
        employeeID: id,
        foreignTravelPostingID,
      }),
    );

  return {
    getPostingRequestOngoing,

    updateAbroadPostingRequestOngoing,
    updateAbroadPostingSuccess,
    updateAbroadPostingFailed,

    updateDeputationPostingRequestOngoing,
    updateDeputationPostingSuccess,
    updateDeputationPostingFailed,

    updatePostingRecordPostingRequestOngoing,
    updatePostingRecordPostingSuccess,
    updatePostingRecordPostingFailed,

    updateForeignTravelPostingRequestOngoing,
    updateForeignTravelPostingSuccess,
    updateForeignTravelPostingFailed,

    deleteAbroadPostingRequestOngoing,
    deleteAbroadPostingSuccess,
    deleteAbroadPostingFailed,

    deleteDeputationPostingRequestOngoing,
    deleteDeputationPostingSuccess,
    deleteDeputationPostingFailed,

    deletePostingRecordPostingRequestOngoing,
    deletePostingRecordPostingSuccess,
    deletePostingRecordPostingFailed,

    deleteForeignTravelPostingRequestOngoing,
    deleteForeignTravelPostingSuccess,
    deleteForeignTravelPostingFailed,

    postingsInfo: postings as PostingsType,

    changeAbroadPostingsInfo,
    changeDeputationPostingsInfo,
    changePostingRecordPostingsInfo,
    changeForeignTravelPostingsInfo,

    removeAbroadPostingInfo,
    removeDeputationPostingInfo,
    removePostingRecordPostingInfo,
    removeForeignTravelPostingInfo,
  };
};
